// import { CommonModalListWrapStyle, CommonModalListItemStyle } from '@styles/base.style'
import styled from '@themes/theme'
import { CommonModalListItemStyle, CommonModalListWrapStyle } from '@styles/modal'

export const ChangeMatchWrap = styled.div`
  min-height: 188px;
  ${CommonModalListWrapStyle};
  .change-match-group {
    ${CommonModalListItemStyle};
    .match-block-header {
      padding: 0 8px;
      text-align: left;
      background: ${props => props.theme.color.modalBg};
      border-top: none;
      .tournament-date, .tournament-name, .country {
        color: ${props => props.theme.color.modalTxt};
        margin-right: 3px;
      }
      .sports-ico {
        width: 16px;
      }
      .league-ico {
        width: 16px;
      }
    }
    .change-match-list {
      position: relative;
      width: 100%;
      &--btn {
        z-index: 0;
        color: ${props => props.theme.color.modalTxt};
        background: ${props => props.theme.color.themeTxt};
        border-radius: 0;
      }
      .line {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        width: 93%;
        height: 1px;
        border-top: 1px solid ${props => props.theme.color.modalDarkBg};
      }
      .score {
        font-size: ${props=>props.theme.font.title};
      }
      &:first-of-type {
        .line {
          display: none;
        }
      }
    }
  }
`
